import React from 'react';
import { LESSON_PLANNER_VIEW } from 'types';
import { DayCardFullSize } from '.';
import { WeekCardList } from './WeekCardList';
import { LessonsPlanLesson } from 'state/modules/entity/types';

type Props = {
  lessons: Array<LessonsPlanLesson>;
  variant: LESSON_PLANNER_VIEW.DAY | LESSON_PLANNER_VIEW.WEEK | LESSON_PLANNER_VIEW.MONTH;
  handleMoveCard: (currentIndex: number, dragIndex: number) => void;
  tourData: { [key: string]: boolean };
};

export const CardSwitch: React.FC<Props> = ({ lessons, variant, tourData, ...props }) => {
  switch (variant) {
    case LESSON_PLANNER_VIEW.DAY:
      return <DayCardFullSize lessons={lessons} />;
    case LESSON_PLANNER_VIEW.WEEK:
      return (
        <WeekCardList lessons={lessons} handleMoveCard={props.handleMoveCard} tourData={tourData} />
      );
    case LESSON_PLANNER_VIEW.MONTH:
      // TBD
      return <div />;
  }
};
